import type {
  PartnerInvoice,
  PartnerInvoiceStatus,
  RequestPartnerInvoiceUploadInput,
} from '@bcl/shared';
import { api } from '@/lib/api';

export type BackofficeInvoice = PartnerInvoice & { partnerName: string | null };

export type InvoiceUploadResponse = {
  invoice: PartnerInvoice;
  uploadUrl: string;
};

export async function requestInvoiceUpload(
  input: RequestPartnerInvoiceUploadInput,
): Promise<InvoiceUploadResponse> {
  const { data } = await api.post<InvoiceUploadResponse>(
    '/partner-invoices/me/upload-url',
    input,
  );
  return data;
}

export async function listMyInvoices(): Promise<PartnerInvoice[]> {
  const { data } = await api.get<PartnerInvoice[]>('/partner-invoices/mine');
  return data;
}

export async function getMyInvoiceDownloadUrl(invoiceId: string): Promise<string> {
  const { data } = await api.get<{ url: string }>(
    `/partner-invoices/me/${invoiceId}/download-url`,
  );
  return data.url;
}

export async function listAllInvoices(
  status?: PartnerInvoiceStatus,
): Promise<BackofficeInvoice[]> {
  const { data } = await api.get<BackofficeInvoice[]>('/partner-invoices', {
    params: status ? { status } : undefined,
  });
  return data;
}

export async function getInvoiceDownloadUrl(invoiceId: string): Promise<string> {
  const { data } = await api.get<{ url: string }>(
    `/partner-invoices/${invoiceId}/download-url`,
  );
  return data.url;
}

export async function payInvoice(
  invoiceId: string,
  paymentReference?: string,
): Promise<PartnerInvoice> {
  const { data } = await api.post<PartnerInvoice>(
    `/partner-invoices/${invoiceId}/pay`,
    paymentReference ? { paymentReference } : {},
  );
  return data;
}
